import Box from '@mui/material/Box';
import Slider from './panelSlider';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';

const SliderSingle = ({
    min,
    max,
    label,
    color,
    callback,
    reset,
    initialValue,
    step = 1,
    unit = '',
    showMinMax = true
}) => {
    const [value, setValue] = useState(initialValue || min);

    const onChange = (event, newValue) => {
        setValue(newValue);
    }

    const onChangeCommitted = (event, newValue) => {
        callback(newValue);
    }

    // Reset slider when reset is changed on filterReset
    useEffect(() => {
        setValue(initialValue || min);
    }, [reset, initialValue, min]);

    // Update value when initialValue changes
    useEffect(() => {
        if (initialValue !== undefined) {
            setValue(initialValue);
        }
    }, [initialValue]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mt: 2, mb: 1 }}>
                <Slider
                    value={value}
                    size="small"
                    valueLabelDisplay="on"
                    marks={false}
                    step={step}
                    min={min}
                    max={max}
                    onChange={onChange}
                    color={color}
                    onChangeCommitted={onChangeCommitted}
                    valueLabelFormat={(value) => `${value}${unit}`}
                />
                {showMinMax && (
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                        <Typography variant="caption" sx={{ fontWeight: 'bold' }} color="text.primary">
                            {min}{unit}
                        </Typography>
                        <Typography variant="caption" sx={{ fontWeight: 'bold' }} color="text.primary">
                            {max}{unit}
                        </Typography>
                    </Box>
                )}
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 0.5 }}>
                    <Typography variant="caption" sx={{ mb: 1, display: 'block', fontWeight: 'bold' }}>
                        {label}: {value}{unit}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default SliderSingle; 